function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M753.2 512c0 8.8-3.4 17.6-10.1 24.4L329.6 949.9c-13.4 13.5-35.3 13.5-48.7 0-13.5-13.4-13.5-35.3 0-48.7L670 512 280.9 122.8c-13.5-13.6-13.5-35.2 0-48.8 13.4-13.4 35.3-13.4 48.7 0l413.5 413.6c6.7 6.8 10.1 15.6 10.1 24.4",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgRight;